import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'wr-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent {

  @Input()
  header: string = '';

  @Input()
  text: string = '';

}
